export default {
  body: {
    cmpt: {
      type: 'CCabinetShipmentDetail'
    }
  }
}
